import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { ExportDialogComponent } from '@core/components/export-dialog/export-dialog.component';
import { ExportDialogTypeEnum } from '@core/components/export-dialog/export-dialog.types';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { AtLeastOneTrueValidation } from '@validators/at-least-one-true.validation';
import { DialogLocationService } from './dialogs/dialog-location/dialog-locations.service';
import { FilterLocationsComponent } from './filter/filter-locations.component';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var LocationComponent = /** @class */ (function () {
    function LocationComponent(fuseTranslationLoaderService, dialogLocationService, authenticationService, fuseSidebarService, formBuilder, matDialog) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.dialogLocationService = dialogLocationService;
        this.authenticationService = authenticationService;
        this.fuseSidebarService = fuseSidebarService;
        this.formBuilder = formBuilder;
        this.matDialog = matDialog;
        this.reload = new EventEmitter();
        this.filtered = false;
        this.showMap = false;
        this.totalCount = 0;
        this.query = {
            name_contains: null,
            archived: false,
            companyId_in: [],
            documentNumber_contains: null
        };
        this.hasEditLocationPermission = this.authenticationService.hasPermission('locations-edit');
        this.hasCreateLocationPermission = this.authenticationService.hasPermission('locations-create');
        this.hasCreateExportPermission = this.authenticationService.hasPermission('exports-create');
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    LocationComponent.prototype.toggleSidebarOpen = function (name) {
        this.fuseSidebarService.getSidebar(name).toggleOpen();
    };
    LocationComponent.prototype.setQuery = function (isFiltered) {
        this.filtered = isFiltered;
    };
    LocationComponent.prototype.clearFilters = function () {
        this.filtered = false;
        this.filters.clearFilters();
    };
    LocationComponent.prototype.openDialog = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dialogLocationService.open({ locationId: null })];
                    case 1:
                        result = _a.sent();
                        if (result && result.reload) {
                            this.reload.next();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LocationComponent.prototype.openExportDialog = function () {
        var optionsForm = this.formBuilder.group({
            locations: true,
            companies: true,
            locationSectors: false,
            locationEnvironments: false,
        }, { validators: AtLeastOneTrueValidation.validate });
        this.matDialog.open(ExportDialogComponent, {
            panelClass: 'export-dialog',
            autoFocus: false,
            data: {
                type: ExportDialogTypeEnum.locations,
                limit: 30000,
                total: this.totalCount,
                optionsForm: optionsForm,
                where: this.filters.filtersChanged.value,
            }
        });
    };
    return LocationComponent;
}());
export { LocationComponent };
